import React from "react";
import { Link } from "react-router-dom"
import useDepartmentDoctors from "../hooks/useDepartmentDoctors"
import DoctorCard from "./DoctorCard"
import { Phone, Mail, MapPin, CheckCircle, Clock, Award, Users,ArrowRight } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Gautham from "../images/Dr. Gautham.png";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
export default function EndocrinologyPage() {
  const { open: openAppointment } = useAppointment();
  const subspecialties = [
    {
      title: "Diabetes Care",
      description: "Comprehensive diabetic management and lifestyle programs.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Hypertension-Diabetic-Nephropathy-Care-scaled.jpg",
    },
    {
      title: "Thyroid Disorders",
      description: "Diagnosis and treatment for hypo/hyperthyroidism and goitre.",
      image: "/ThyroidDisorders.jpg",
    },
    {
      title: "Adrenal & Pituitary Disorders",
      description: "Management of hormonal gland disorders.",
      image: "/Adrenal&PituitaryDisorders.jpg",
    },
    {
      title: "Osteoporosis & Bone Metabolism",
      description: "Treatment for calcium and bone-related diseases.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Osteoporosis-Bone-Metabolism-scaled.jpg",
    },
    {
      title: "Pediatric Endocrinology",
      description: "Hormonal care for growth and puberty issues in children.",
      image: "/PediatricEndocrinology.jpg",
    },
  ];

  const treatments = [
    "Diabetes & Insulin Therapy",
    "Thyroid Function Evaluation ",
    "Obesity Treatment",
    "Adrenal & Pituitary Disorder Management",
    "Holistic Care Bariatic Surgery",
    
  ];

  const whyChoose = [
    { icon: Users, text: "Skilled endocrinologists with personalized treatment plans" },
    { icon: Award, text: "Integrated diabetes and metabolic clinics" },
    { icon: CheckCircle, text: "Modern lab support for accurate hormonal testing" },
    { icon: Clock, text: "Preventive programs for long-term health management" },
    { icon: MapPin, text: "Convenient location near Miyapur & Bachupally" },
  ];

  const doctors = useDepartmentDoctors("Endocrinology");

  const articles = [
    { title: "How to Manage Diabetes Effectively", icon: "🍭" },
    { title: "Common Thyroid Disorders and Symptoms", icon: "🦋" },
    { title: "The Role of Hormones in Weight Management", icon: "💪" },
    { title: "Lifestyle Changes for Healthy Blood Sugar Control", icon: "🩸" },
  ];

  const faqs = [
    {
      question: "What conditions do endocrinologists treat?",
      answer: "They manage diabetes, thyroid problems, obesity, and hormonal imbalances.",
    },
    {
      question: "Is thyroid disease curable?",
      answer: "Most thyroid disorders are easily controlled with timely treatment and monitoring.",
    },
    {
      question: "Do you have diabetes management programs?",
      answer: "Yes, MAMS Hospitals offers personalized diabetes care and education programs.",
    },
  ];
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "MedicalClinic",
      "name": "MAMS Hospitals Endocrinology Department",
      "url": "https://mamshospitals.com/endocrinology",
      "logo": "https://mamshospitals.com/MAMS-Logo.png",
      "image": "https://mamshospitals.com/Endocrinology.jpg",
      "description": "MAMS Hospitals provides advanced endocrinology treatment in Hyderabad including diabetes care, thyroid disorder treatment, obesity management, hormonal disorder treatment, and metabolic care.",
      "medicalSpecialty": "Endocrinology",
      "telephone": "+91-7399999981",
      "priceRange": "$$",

      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Bachupally",
        "addressLocality": "Hyderabad",
        "addressRegion": "Telangana",
        "postalCode": "500090",
        "addressCountry": "IN"
      },

      "availableService": [
        {
          "@type": "MedicalProcedure",
          "name": "Diabetes Management"
        },
        {
          "@type": "MedicalProcedure",
          "name": "Thyroid Disorder Treatment"
        },
        {
          "@type": "MedicalProcedure",
          "name": "Obesity Treatment"
        },
        {
          "@type": "MedicalProcedure",
          "name": "Hormonal Disorder Treatment"
        },
        {
          "@type": "MedicalProcedure",
          "name": "Metabolic Disorder Management"
        }
      ],

      "sameAs": [
        "https://www.facebook.com/MAMSHospitals",
        "https://www.instagram.com/mams_hospitals"
      ]
    },

    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What conditions do endocrinologists treat?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Endocrinologists treat diabetes, thyroid disorders, obesity, hormonal imbalance, adrenal disorders, and metabolic diseases."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide diabetes management programs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, MAMS Hospitals offers personalized diabetes management and lifestyle modification programs."
          }
        },
        {
          "@type": "Question",
          "name": "Do you treat thyroid disorders?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, MAMS Hospitals provides advanced diagnosis and treatment for thyroid disorders and hormonal conditions."
          }
        }
      ]
    },

    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Endocrinology Department - MAMS Hospitals",
      "url": "https://mamshospitals.com/endocrinology",
      "description": "Best endocrinology hospital in Hyderabad offering diabetes care, thyroid treatment, obesity management, and hormonal disorder treatment.",
      "keywords": [
        "Endocrinology Hospital Hyderabad",
        "Best Endocrinologist Hyderabad",
        "Diabetes Specialist Hyderabad",
        "Thyroid Treatment Hyderabad",
        "Hormone Specialist Hyderabad",
        "Obesity Treatment Hyderabad",
        "Endocrinology Hospital Bachupally"
      ]
    }
  ];
  return (
    <>
    <SEO
      title="Best Endocrinology Hospital in Hyderabad | Diabetes & Thyroid Care | MAMS Hospitals"
      description="MAMS Hospitals offers advanced endocrinology treatment in Hyderabad including diabetes care, thyroid disorder treatment, obesity management, and hormonal disorder treatment."
      keywords="endocrinology hospital Hyderabad,
      best endocrinologist Hyderabad,
      diabetes specialist Hyderabad,
      thyroid treatment Hyderabad,
      hormone specialist Hyderabad,
      obesity treatment Hyderabad,
      diabetes care Hyderabad,
      thyroid doctor Hyderabad,
      metabolic disorder treatment Hyderabad,
      hormonal imbalance treatment Hyderabad,
      endocrinology hospital Bachupally,
      diabetes clinic Hyderabad,
      MAMS Hospitals Endocrinology"
      schema={schema}
  />
    <div className="flex flex-col min-h-screen">

      {/* HERO SECTION */}
      <section className="relative bg-gradient-to-br from-primary/10 via-primary/5 to-background py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

          <div>
            <div className="inline-block bg-primary/10 text-primary px-4 py-1 rounded-full text-sm font-medium mb-4">
              Expert Endocrine Care
            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-primary mb-6 leading-tight">
              Balancing Hormones, Empowering Health
            </h1>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              MAMS Hospitals is one of the Best Endocrinology Hospitals in Hyderabad offering expert care for
              hormonal and metabolic disorders.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
          </div>

          <div className="relative mt-8 md:mt-0">
            <img
              src="/Endocrinology.jpg"
              alt="Endocrinology Care"
              className="rounded-2xl shadow-2xl w-full"
            canonicalUrl="https://mamshospitals.com/departments/endocrinology"
      />

            <div className="absolute -bottom-3 left-2 sm:-bottom-4 sm:-left-4 bg-white p-3 sm:p-6 rounded-xl shadow-xl">
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 p-3 rounded-full">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-primary">95%</p>
                  <p className="text-sm text-gray-600">Success Rate</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* SUBSPECIALTIES */}
      <section className="py-16 md:py-20 px-0">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Sub-Specialties in Endocrinology</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Comprehensive hormonal and metabolic care
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((item, i) => (
              <Card key={i} className="overflow-hidden hover:shadow-lg transition">
                <div className="relative h-48">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-primary">{item.title}</h3>
                  <p className="text-gray-600 mt-2">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section>

      {/* TREATMENTS */}
      <section className="py-16 md:py-20 px-0 bg-slate-50">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary">Treatments & Procedures</h2>
            <p className="text-gray-600">Advanced endocrine treatments</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {treatments.map((text, i) => (
              <Card key={i} className="hover:shadow-lg transition">
                <CardContent className="p-6">
                  <div className="flex items-center gap-4">
                    <div className="bg-primary/10 p-3 rounded-full">
                      <CheckCircle className="w-6 h-6 text-primary" />
                    </div>
                    <p className="text-gray-800 font-medium">{text}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="py-16 md:py-20 px-0">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary">Why Choose MAMS Hospitals</h2>
            <p className="text-gray-600">Your trusted partner for endocrine care</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, i) => {
              const Icon = item.icon;
              return (
                <Card key={i} className="hover:shadow-lg transition">
                  <CardContent className="p-6">
                    <div className="flex gap-4 items-start">
                      <div className="bg-primary/10 p-3 rounded-full">
                        <Icon className="w-6 h-6 text-primary" />
                      </div>
                      <p className="text-gray-700">{item.text}</p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

        </div>
      </section>

      {/* SPECIALIST */}
      {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}


      {/* ARTICLES */}
      {/* <section className="py-16 md:py-20 px-0">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary">Recent Articles</h2>
            <p className="text-gray-600">Stay informed about endocrine health</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {articles.map((a, i) => (
              <Card key={i} className="hover:shadow-lg cursor-pointer transition">
                <CardContent className="p-6">
                  <div className="flex items-center gap-4 text-gray-900">
                    <span className="text-4xl">{a.icon}</span>
                    <h3 className="text-lg font-semibold">{a.title}</h3>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section> */}

      {/* FAQ SECTION */}
      <section className="py-16 md:py-20 px-0 bg-slate-50">
        <div className="container mx-auto max-w-4xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-primary">Frequently Asked Questions</h2>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-white rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold hover:text-primary">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 className="font-semibold mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>
    </>
  );
}
